import { render } from "./CustomerDetailAccountStatementTab.vue?vue&type=template&id=1bfd472c"
import script from "./CustomerDetailAccountStatementTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailAccountStatementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__